import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import Tabs, { TabContainer } from 'Components/Tabs';
import LandmarkList from './components/landmarkList'
import LandmarkSettings from './components/landmarkSettings'
import LandmarkVisibleTags from './components/landmarkVisibleTags'
import LandmarkImportDetail from './components/landmarkImport/components/landmarkImportDetail'
import { NotificationManager } from 'Components/Notifications';
import { injectIntl } from 'react-intl';
import { HasPermission } from "Core/security"
import { useSelector } from "react-redux";
import { MapUtilitiesTypes } from '../MapUtilitiesMenu/enums';

// Actions
import {
    clearRedux,
    selectModuleMapSettings,

    searchLandmarkTransaction
} from "Redux/actions";

var varLocaleLan = localStorage.getItem('lan');

const Landmarks = (props) => {
    const { mapRef, intl } = props
    const { messages, locale } = intl;
    const dispatch = useDispatch();
    const [tab, setTab] = useState(0);
    const [resumeTransactions, setResumeTransactions] = useState([]);
    const user = useSelector((state) => state.securityRedux.user);
    const migrationPushNotification = useSelector(state => state.catalogsRedux.migrationPushNotification);
    const transactions = useSelector((state) => state.landmarkImportSliceRedux.transactions);
    let indexCount = 0

    useEffect(() => {
        if (migrationPushNotification?.transactionId) {
            dispatch(searchLandmarkTransaction({ transactionId: migrationPushNotification?.transactionId, nextToken: '' }));
            dispatch(clearRedux("CATALOG_REDUX", { migrationPushNotification: {} }))
        }
    }, [migrationPushNotification]);

    useEffect(()=> {
        if(varLocaleLan != locale){
          dispatch(selectModuleMapSettings(MapUtilitiesTypes.Default));
          varLocaleLan = locale
        }
    },[locale])

    useEffect(() => {
        if (transactions && transactions?.items?.length > 0) {

            let resume = resumeTransactions;
            transactions?.items?.forEach((data) => {
                if (data.ErrorMessage) {
                    let dataDriver = JSON.parse(JSON.parse(data.Data));
                    resume.push({
                        ...dataDriver,
                        id: data.Id,
                        error: data.ErrorMessage
                    })
                }
            });
            setResumeTransactions(resume)

            if (transactions?.nextToken) {
                if (transactions && transactions?.items?.length > 0){
                    dispatch(searchLandmarkTransaction({ transactionId: transactions?.items[0]?.TransactionId, nextToken: transactions?.nextToken }));
                }
            } else {

                if (resumeTransactions?.length > 0 || resume?.length > 0) {
                    NotificationManager.error(
                        messages['mapLandmarkImport_correctErrors'],
                        messages['error'],
                        5000,
                        () => { setTab(indexCount) },
                        null,
                        'warning',
                    );
                } else {
                    NotificationManager.success(
                        messages['settingsDriver_importation_title'],
                        messages['mapLandmarkImport_success'],
                        3000,
                        null,
                        null,
                        'success',
                        null
                    );
                }
            }
        } else {
            setResumeTransactions([])
        }
    }, [transactions]);


    return (
        <Tabs
            tab={tab}
            type="icon-indicator"
            border
            onChange={(tab) => {
                setTab(tab)
            }}
        >

            {HasPermission(user, '', [3]) &&
                <TabContainer style={{ padding: '16px 0px 24px 0px' }} iconIndicator="flag" label={messages['map_landmark_landmarkgroups']} index={indexCount++}>
                    { tab == 0 && <LandmarkList mapRef={mapRef} /> }
                </TabContainer>
            }
            {HasPermission(user, '', [3]) &&
                <TabContainer style={{ padding: '16px 0px 24px 0px' }} iconIndicator="build" label={messages['map_landmark_manage_landmarks']} index={indexCount++}>
                   { tab == 1 && <LandmarkSettings mapRef={mapRef} /> }
                </TabContainer>
            }

            {
                //HasPermission(user, '', [3]) &&
                //<TabContainer style={{ padding: '16px 0px 24px 0px' }} iconIndicator="visibility" label={messages['map_landmark_manage_visibility']} index={indexCount++}>
                //    <LandmarkVisibleTags mapRef={mapRef} />
                //</TabContainer>
            }

            {
                resumeTransactions?.length > 0 &&
                <TabContainer style={{ padding: '16px 0px 24px 0px' }} iconIndicator="upload" label={'Uploads'} index={indexCount++} badge={resumeTransactions?.length} >
                    <LandmarkImportDetail resumeTransactions={resumeTransactions} callBack={(transationCallBack) => { setResumeTransactions(transationCallBack); }} handleClose={() => { setResumeTransactions([]); setTab(0) }} />
                </TabContainer>
            }

        </Tabs>
    )
}

export default injectIntl(Landmarks)